import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ProductcheckoutconfirmComponent } from './product-checkout-confirm.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule, JsonpModule } from '@angular/http';

const routes: Routes = [{
	path: '',
	data: {
      title: 'myIHSAA Store Checkout Confirmation',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Checkout Confirmation'}]
    },
	component: ProductcheckoutconfirmComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule,
		HttpModule,
        JsonpModule,
        NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [ProductcheckoutconfirmComponent]
})
export class ProductcheckoutconfirmModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/ecommerce/product-checkout-confirm/product-checkout-confirm.module.ts